import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bb841c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "waiting"
}
const _hoisted_2 = { class: "error" }



type Props = {
  error: string | null;
  waitingMessage: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowErrorLoading',
  props: {
    error: null,
    waitingMessage: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.waitingMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(__props.waitingMessage), 1),
          _createVNode(_component_v_progress_circular, { indeterminate: "" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (__props.error)
        ? (_openBlock(), _createBlock(_component_v_alert, {
            key: 0,
            type: "error",
            density: "compact",
            closable: "",
            location: "center"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.error), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})